<template>
    <div :class="['flex gap-2', longDescription ? 'items-top' : 'items-center']">
        <input
            :checked="value"
            :class="[
                `rounded border-gray-300 focus:ring-${colorScheme}-500`,
                backgroundClass,
                disabled ? 'cursor-not-allowed' : 'cursor-pointer',
                sizeClass,
            ]"
            :disabled="disabled"
            type="checkbox"
            @click="updateValue"
        >
        <label :class="['cursor-pointer flex items-center', fullWidth ? 'w-full' : '']" @click="updateValue">
            <slot />
        </label>
    </div>
</template>

<script>
    import advisory_partner_mixin from '@/mixins/advisory_partner_mixin';

    export default {
        mixins: [
            advisory_partner_mixin,
        ],
        props: {
            big: {
                default: false,
                type: Boolean,
            },
            color: {
                default: '',
                type: String,
            },
            disabled: {
                default: false,
                type: Boolean,
            },
            longDescription: {
                default: false,
                type: Boolean,
            },
            small: {
                default: false,
                type: Boolean,
            },
            value: {
                default: false,
                type: Boolean,
            },
            fullWidth: {
                default: false,
                type: Boolean,
            },
        },
        computed: {
            backgroundClass() {
                if (this.disabled) return 'bg-gray-100';
                return this.value ? `text-${this.color || this.colorScheme}-500` : 'bg-white';
            },
            sizeClass() {
                let size = this.big ? '6' : this.small ? '4' : '5';
                if (this.big && this.small) {
                    console.error('VCheckbox: big and small props are mutually exclusive');
                    size = 5;
                }
                return `h-${size} w-${size}`;
            },
        },
        methods: {
            updateValue() {
                if (this.disabled) return;
                this.$emit('input', !this.value);
                this.$emit('change', !this.value);
            },
        },
    };
</script>
